import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormBaseComponent } from "./../form-base/form-base.component";

@Component({
  selector: "app-form-titulo-publico",
  templateUrl: "./form-titulo-publico.component.html",
  styleUrls: ["../form-base/form-base.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTituloPublicoComponent extends FormBaseComponent {}
